<ng-container class="santa-flex santa-flex-col" *ngIf="(state?.relatedPosts?.length ?? 0) > 0">
  <span class="santa-flex santa-typo-h3 santa-mb-20 santa-text-black-700">
    {{ translations.relatedPosts | translate }}
  </span>

  <div [class.post-card-tile]="!state.isMobileScreen">
    <ng-container *ngFor="let post of state.relatedPosts; let i = index; trackBy: trackByFn">
      <div
        [ngClass]="{
          'post-card-tall': (i + 1) % 3 === 0 && !state.isMobileScreen,
          'santa-mb-20': state.isMobileScreen
        }"
      >
        <a href="" [routerLink]="getPostPageRouterLink(post)">
          <ng-container *ngIf="state.isMobileScreen">
            <alliance-clubs-posts-card-mobile [post]="post" [withImg]="false" [withRubrics]="false" [titleClasses]="'santa-typo-large-bold'"></alliance-clubs-posts-card-mobile>
          </ng-container>
          <ng-container *ngIf="!state.isMobileScreen">
            <alliance-clubs-posts-card-desktop [post]="post" [withImg]="false" [withRubrics]="false" [titleClasses]="'santa-typo-large-bold'"></alliance-clubs-posts-card-desktop>
          </ng-container>
        </a>
      </div>
    </ng-container>
  </div>
</ng-container>
